import React from 'react';
import PropTypes from 'prop-types';

export default class Shadow extends React.Component {
  static propTypes = {
    canExportShadows: PropTypes.bool,
    context: PropTypes.object,
    shadowInputOverridesUrl: PropTypes.string,
    stylesheetUrl: PropTypes.string,
    url: PropTypes.string.isRequired,
  }

  iframeRef = React.createRef();

  get url() {
    const url = new URL(this.props.url);

    url.searchParams.append('permitDownload', !!this.props.canExportShadows);

    if (this.props.context) {
      for (const key in this.props.context) {
        url.searchParams.append('contextKey', key);
        url.searchParams.append('contextValue', this.props.context[key]);
      }
    }

    if (this.props.stylesheetUrl) {
      url.searchParams.append('stylesheet', this.props.stylesheetUrl);
    }

    if (this.props.shadowInputOverridesUrl) {
      url.searchParams.append('inputOverridesUrl', this.props.shadowInputOverridesUrl);
    }

    return url.toString();
  }

  focusIframe = () => {
    this.iframeRef.current.focus();
  }

  render() {
    const { stylesheetUrl, shadowInputOverridesUrl, url, ...props } = this.props;
    return <iframe ref={this.iframeRef} src={this.url} onLoad={this.focusIframe} {...props} />;
  }
}
